import React from 'react';
import clsx from 'clsx';

/**
 * A titled block inside a drawer, modal or card. Use it instead of nesting
 * small Cards inside a modal: sections read as one document, nested cards as
 * a pile of boxes.
 */
const Section = ({ title, description, extra, children, className, flush = false }) => (
  <section className={clsx('admin-section', { 'admin-section--flush': flush }, className)}>
    {title || description || extra ? (
      <div className="admin-section__head">
        <div>
          {title ? <h3 className="admin-section__title">{title}</h3> : null}
          {description ? <p className="admin-section__desc">{description}</p> : null}
        </div>
        {extra ? <div className="admin-section__extra">{extra}</div> : null}
      </div>
    ) : null}
    {children}
  </section>
);

export default Section;
